"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSurveyReminderCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const commands_1 = require("../../_shared/commands");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
const RemindLater_1 = require("./RemindLater");
function createSurveyReminderCard(survey, threadId, messageId, tenantId) {
    const card = CardHelper_1.CardHelper.newCard();
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: "Your Reminder To Take Polly",
        color: adaptivecards_1.TextColor.Attention,
    }));
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: survey.title,
    }));
    card.addAction((0, commands_1.SurveyDeepLinkAction)(tenantId, survey.type, null, threadId, messageId));
    card.addAction(CardHelper_1.CardHelper.create(adaptivecards_1.ShowCardAction, {
        title: "Snooze",
        card: (0, RemindLater_1.createRemindLaterCard)(survey.id, threadId, messageId),
    }));
    return card;
}
exports.createSurveyReminderCard = createSurveyReminderCard;
//# sourceMappingURL=SurveyReminder.js.map